import {
  Alert,
  Checkbox,
  FormControlLabel,
  FormGroup,
  FormLabel,
  Typography,
} from "@mui/material";
import MuiButton from "../../components/basicComponent/MuiButton";
import { MuiDropDown } from "../../components/basicComponent/MuiDropDown";
import Header from "../../sharedScreens/Header";
import SideMenu from "../../sharedScreens/menuItems/SideMenu";
import React from "react";
import MuiSearchSelect from "../../components/basicComponent/MuiSearchSelect";
import MuiUploader from "../../components/basicComponent/MuiUploader";
import { MuiInput } from "../../components/basicComponent/MuiInput";
import MuiDatePicker from "../../components/basicComponent/MuiDatePicker";

const AirlinePenaltyCharges = () => {
  return (
    <div className="grow">
      <SideMenu />
      <div className="wrapper flex grow flex-col">
        <Header />
        <main className="grow content" id="content" role="content">
          <div className="container-fixed">
            <div className="card-header text-center">
              <h3 className="card-title">Airline Penalty Charges</h3>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="card card-custom">
                  <div className="card-body">
                    <div className="row mt-4">
                      <div className="col-md-4">
                        <MuiDropDown
                          label="Service Type"
                          placeholder={"Service Type"}
                          options={[]}
                          onChange={function (value: string, id: string): void {
                            throw new Error("Function not implemented.");
                          }}
                          value={""}
                        />
                      </div>
                      <div className="col-md-4">
                        <MuiDropDown
                          label="Airport Type"
                          placeholder={"Airport Type"}
                          options={[]}
                          onChange={function (value: string, id: string): void {
                            throw new Error("Function not implemented.");
                          }}
                          value={""}
                        />
                      </div>
                      <div className="col-md-4">
                        <MuiDropDown
                          label="Supplier Name"
                          placeholder={"Supplier Name"}
                          options={[]}
                          onChange={function (value: string, id: string): void {
                            throw new Error("Function not implemented.");
                          }}
                          value={""}
                        />
                      </div>
                      <div className="col-md-4 mt-3">
                        <MuiDropDown
                          label="Airline Name"
                          placeholder={"Airline Name"}
                          options={[]}
                          onChange={function (value: string, id: string): void {
                            throw new Error("Function not implemented.");
                          }}
                          value={""}
                        />
                      </div>
                      <div className="col-md-4 mt-3">
                        <MuiDropDown
                          label="Fare Type"
                          placeholder={"Fare Type"}
                          options={[]}
                          onChange={function (value: string, id: string): void {
                            throw new Error("Function not implemented.");
                          }}
                          value={""}
                        />
                      </div>

                      <div
                        style={{
                          display: "flex",
                          justifyContent: "flex-end",
                          gap: "10px",
                          marginTop: "8px",
                        }}
                      >
                        <div className="user-button w-full">
                          <MuiButton
                            className="clear-btn "
                            label="Clear"
                            type="submit"
                          />
                          <MuiButton
                            className="main-btn get-btn"
                            variant="contained"
                            size="large"
                            type="submit"
                            label={"Get"}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="container-fixed">
            <div className="card-header text-center">
              <h3 className="card-title">Airline Penalty Charges</h3>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="card changepass-card">
                  <div className="card-body mt-4">
                    <div className="row">
                      <div className="col-xl-4 col-lg-6 col-md-6 mb-3">
                        <MuiSearchSelect
                          placeholder="Service Type"
                          label={"Service Type"}
                          isRequired={true}
                          options={[]}
                          onChange={function (
                            value: string,
                            id: string,
                            data: any
                          ): void {
                            throw new Error("Function not implemented.");
                          }}
                          value={""}
                        />
                      </div>

                     <div className="col-xl-4 col-lg-6 col-md-6 mb-3">
                        <MuiSearchSelect
                          placeholder="Airport Type"
                          label={"Airport Type"}
                          isRequired={true}
                          options={[]}
                          onChange={function (
                            value: string,
                            id: string,
                            data: any
                          ): void {
                            throw new Error("Function not implemented.");
                          }}
                          value={""}
                        />
                      </div>
                     <div className="col-xl-4 col-lg-6 col-md-6 mb-3">
                        <MuiSearchSelect
                          placeholder="Supplier Name"
                          label={"Supplier Name"}
                          isRequired={true}
                          options={[]}
                          onChange={function (
                            value: string,
                            id: string,
                            data: any
                          ): void {
                            throw new Error("Function not implemented.");
                          }}
                          value={""}
                        />
                      </div>

                   <div className="col-xl-4 col-lg-6 col-md-6 mb-3">
                        <MuiSearchSelect
                          placeholder="Airline Name"
                          label={"Airline Name"}
                          isRequired={true}
                          options={[]}
                          onChange={function (
                            value: string,
                            id: string,
                            data: any
                          ): void {
                            throw new Error("Function not implemented.");
                          }}
                          value={""}
                        />
                      </div>
                      <div className="col-xl-4 col-lg-6 col-md-6 mb-3">
                        <MuiSearchSelect
                          placeholder="Fare Type"
                          label={"Fare Type"}
                          isRequired={true}
                          options={[]}
                          onChange={function (
                            value: string,
                            id: string,
                            data: any
                          ): void {
                            throw new Error("Function not implemented.");
                          }}
                          value={""}
                        />
                      </div>
                      <div className="col-xl-4 col-lg-4 col-md-6 mb-3">
                        <MuiInput
                          placeholder="Fare Description"
                          label={"Fare Description"}
                          isRequired={true}
                        />
                      </div>
                      <div className="col-xl-4 col-lg-6 col-md-6 mb-3">
                        <MuiSearchSelect
                          placeholder="Cabin "
                          label={"Cabin "}
                          isRequired={true}
                          options={[]}
                          onChange={function (
                            value: string,
                            id: string,
                            data: any
                          ): void {
                            throw new Error("Function not implemented.");
                          }}
                          value={""}
                        />
                      </div> 
                      <div className="col-xl-4 col-lg-4 col-md-6 mb-3">
                        <MuiInput
                          placeholder="Class"
                          label={"Class"}
                          isRequired={true}
                        />
                      </div>

                      <div className="row mt-3">
                        <FormLabel
                          sx={{ color: " #38aecc", fontWeight: "bold" }}
                        >
                         Include
                          <span style={{ color: "red" }}>*</span>
                        </FormLabel>
                        <FormGroup
                          sx={{
                            border: "1px solid #ccc",
                            padding: "8px",
                            borderRadius: "4px",
                            width: "100%",
                            height: "74px",
                          }}
                        >
                          <div className="row">
                          <div className="col-xl-4 col-lg-4 col-md-6 mb-3">
                        <MuiInput
                          placeholder="Fare Description"
                          label={"Fare Description"}
                          isRequired={true}
                        />
                      </div>
                      <div className="col-xl-4 col-lg-6 col-md-6 mb-3">
                        <MuiSearchSelect
                          placeholder="Cabin "
                          label={"Cabin "}
                          isRequired={true}
                          options={[]}
                          onChange={function (
                            value: string,
                            id: string,
                            data: any
                          ): void {
                            throw new Error("Function not implemented.");
                          }}
                          value={""}
                        />
                      </div> 
                      <div className="col-xl-4 col-lg-4 col-md-6 mb-3">
                        <MuiInput
                          placeholder="Class"
                          label={"Class"}
                          isRequired={true}
                        />
                      </div>
                          </div>
                        </FormGroup>
                      </div>

                      <div className="row mt-3">
                        <FormLabel
                          sx={{ color: " #38aecc", fontWeight: "bold" }}
                        >
                         Exclude
                          <span style={{ color: "red" }}>*</span>
                        </FormLabel>
                        <FormGroup
                          sx={{
                            border: "1px solid #ccc",
                            padding: "8px",
                            borderRadius: "4px",
                            width: "100%",
                            height: "74px",
                          }}
                        >
                          <div className="row">
                          <div className="col-xl-4 col-lg-4 col-md-6 mb-3">
                        <MuiInput
                          placeholder="Fare Description"
                          label={"Fare Description"}
                          isRequired={true}
                        />
                      </div>
                      <div className="col-xl-4 col-lg-6 col-md-6 mb-3">
                        <MuiSearchSelect
                          placeholder="Cabin "
                          label={"Cabin "}
                          isRequired={true}
                          options={[]}
                          onChange={function (
                            value: string,
                            id: string,
                            data: any
                          ): void {
                            throw new Error("Function not implemented.");
                          }}
                          value={""}
                        />
                      </div> 
                      <div className="col-xl-4 col-lg-4 col-md-6 mb-3">
                        <MuiInput
                          placeholder="Class"
                          label={"Class"}
                          isRequired={true}
                        />
                      </div>
                          </div>
                        </FormGroup>
                      </div>

                 

                      <div className="pb-2 user-button w-full text-end onboard-btn">
                        <MuiButton
                          className="main-clear-btn"
                          label="Clear"
                          type="submit"
                        />
                        <MuiButton
                          label="Create"
                          type="submit"
                          // disabled={!formik.dirty || !form/ik.isValid}
                          variant="outlined"
                          fullWidth={false}
                          className="main-btn"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default AirlinePenaltyCharges;
